import { DataBean } from "../DataBean";

export class Comparison extends DataBean {


    public async getComparisonCatalogPorPropiedades(properties:any,maxRows:any): Promise<any> {
        return this.getCustomService("TalentERP", "java.util.List_getComparisonCatalogPorPropiedades_java.util.Map_Number", [properties,maxRows]);
    }

    

    public async getComparisonCatalogByPropertiesRender(properties:any,maxRows:any): Promise<any> {
        return this.getCustomService("CacheOptions", "java.util.List_getComparisonCatalogByPropertiesRender_java.util.Map_Number", [properties,maxRows]);
    }


 
}